import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import Selector from './Selector';
import './TimerangeSelector.css';

import brandingStyles from '../branding/brandingStyles';

class TimerangeSelector extends Component {

    constructor(props) {
        super(props);
        this.handleApply = this.handleApply.bind(this);
    }

    handleApply(event, picker) {
        this.props.setDatesFunc(picker.startDate, picker.endDate);
    }

    getFormat(interval) {
        switch (interval) {
        case 'months':
            return 'MMM Y';
        case 'days':
            return 'MMM Do Y';
        default:
            return 'MMM Y';
        }
    }

    render() {
        const ranges = {
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment()],
            'Last Month': [moment().subtract(1, 'month')
            .startOf('month'), moment().subtract(1, 'month').endOf('month')],
            'This Year': [moment().startOf('year'), moment()],
            'Last Year': [moment().subtract(1, 'year')
            .startOf('year'), moment().subtract(1, 'year').endOf('year')],
        };

        const intervals = [
            {
                id: '1',
                label: 'Monthly',
                value: 'months',
            },
            {
                id: '2',
                label: 'Daily',
                value: 'days',
            },
        ];

        return (
          <div>
            <DateRangePicker
              parentEl="body"
              startDate={moment(this.props.startDate)}
              endDate={moment(this.props.endDate)}
              ranges={ranges}
              opens="right"
              isInvalidDate={this.props.isInvalidDate}
              onApply={this.handleApply}
              timePicker={true}
              timePickerIncrement={15}
            >
                <button
                  className="btn btn-default"
                  style={brandingStyles.buttons.primary}
                >
                  <i className="fa fa-calendar"/>
                  &nbsp;
                  {this.props.startDate.format(
                    this.getFormat(this.props.interval)
                  )}
                  &nbsp;
                  <i className="fa fa-long-arrow-right"/>
                  &nbsp;
                  {this.props.endDate.format(
                    this.getFormat(this.props.interval)
                  )}
                </button>
            </DateRangePicker>
            {(this.props.interval && this.props.setIntervalFunc) &&
              (
                <label
                  className="pull-right"
                >
                  <span
                    style={
                      Object.assign(
                          {
                              display: 'inline-block',
                              marginTop: '7px',
                              marginRight: '15px',
                          },
                        brandingStyles.fontColor
                      )
                    }
                  >
                    Interval :
                  </span>
                  <Selector
                    values={intervals}
                    selected={this.props.interval}
                    selectValue={this.props.setIntervalFunc}
                  />
                </label>
              )
            }
          </div>
        );
    }
}

TimerangeSelector.propTypes = {
    startDate: PropTypes.object.isRequired,
    endDate: PropTypes.object.isRequired,
    setDatesFunc: PropTypes.func.isRequired,
    interval: PropTypes.string, // only if interval is needed
    setIntervalFunc: PropTypes.func, // only if interval is needed
    isInvalidDate: PropTypes.func,
};

export default TimerangeSelector;



/** WEBPACK FOOTER **
 ** ./src/utils/TimerangeSelector.js
 **/